export default __webpack_public_path__ + "static/media/lightBluePoint.5d5f7197.png";